/* eslint-disable no-console */
import {config} from '@app/modules/config';

export const getClientById = async (clientId: string) => {
	try {
		const response = await fetch(
			`${config.get('oauthServiceUrl')}/api/client/${clientId}`,
			{
				headers: {
					'X-Api-Key': config.get('publicAPIKey'),
				},
			},
		);
		return await response.json();
	} catch (error) {
		console.log(error);
	}
};

export const saveUserPermissions = async ({
	clientId,
	jwt,
	scopes,
}: {
	clientId: string;
	jwt: string;
	scopes: string[];
}) => {
	try {
		const response = await fetch(
			`${config.get('oauthServiceUrl')}/api/permissions/${clientId}`,
			{
				method: 'POST',
				body: JSON.stringify({scopes: scopes}),
				headers: {
					Authorization: `Bearer ${jwt}`,
					'Content-Type': 'application/json',
				},
			},
		);
		return response;
	} catch (error) {
		console.log(error);
	}
};

export const getUserPermissions = async (jwt: string) => {
	try {
		const response = await fetch(
			`${config.get('oauthServiceUrl')}/api/permissions`,
			{
				method: 'GET',
				headers: {
					Authorization: `Bearer ${jwt}`,
				},
			},
		);
		const data = await response.json();
		if (data.error_code) {
			return null;
		}
		return data;
	} catch (error) {
		console.log(error);
	}
};

export const getUserPermissionsByClientId = async ({
	clientId,
	jwt,
}: {
	clientId: string;
	jwt: string;
}) => {
	try {
		const response = await fetch(
			`${config.get('oauthServiceUrl')}/api/permissions/${clientId}`,
			{
				method: 'GET',
				headers: {
					Authorization: `Bearer ${jwt}`,
					'Content-Type': 'application/json',
				},
			},
		);
		const data = await response.json();
		return data;
	} catch (error) {
		console.log(error);
	}
};

export const deletePermissions = async (clientId: string, jwt: string) => {
	return await fetch(
		`${config.get('oauthServiceUrl')}/api/permissions/${clientId}`,
		{
			method: 'DELETE',
			headers: {
				Authorization: `Bearer ${jwt}`,
			},
		},
	);
};
